
import { Inject, Injectable, DOCUMENT } from "@angular/core";
import StorageHelper from "../helpers/storage.helper";
import { WINDOW } from "../providers/window.provider";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
export class DarkModeService {
    private isDarkMode: boolean = false;
    private readonly localStorageKey = 'Calario.dark-mode';
    private readonly darkModeCssClassName = 'dark-mode';

    public readonly isDarkMode$ = new BehaviorSubject<boolean>(this.isDarkMode);

    constructor(@Inject(DOCUMENT) private readonly document: Document,
        @Inject(WINDOW) private readonly window: Window) {
    }

    public initialize(): void {
        const prefersDarkMode = this.window.matchMedia("(prefers-color-scheme: dark)").matches;
        const savedDarkMode = StorageHelper.getItemAsObject<boolean>(localStorage, this.localStorageKey);

        if(savedDarkMode == this.isDarkMode){
            this.toggle();
        }
    }

    public toggle() : void {
        this.isDarkMode = this.document.body.classList.toggle(this.darkModeCssClassName);
        StorageHelper.setItemFromObject<boolean>(localStorage, this.localStorageKey, this.isDarkMode);
        this.isDarkMode$.next(this.isDarkMode);
    }

    public getIsDarkMode(): boolean {
        return this.isDarkMode;
    }
}